export const getNextField = (array: string[], current: string) => {
  const index = array.indexOf(current)
  return array[index + 1] || array[index]
}
